module.exports = __webpack_public_path__ + "assets/f681029ad9c421c1638ad497aae315c1.png";